import React from 'react';
import Icons from "../../assets/icons/icons.svg";

const Icon = (props) => {
    const classes = `${props.className ? props.className : ''}`;
    const iconName = `${Icons}#${props.name}`;
    return (
        <svg className={classes} viewBox="0 0 10 10" style={
            {
                width: props.width ? props.width : null,
                height: props.height ? props.height : null,
                fill: props.fill ? 'var(--bs-' + props.fill + ')' : 'var(--bs-body-color)',
            }
        }>
            <use href={iconName}/>
        </svg>

    );
};

export default Icon;

